<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 mb-3">
  <div class="col-md-12">
    <div class="custom-tab-switcher d-flex">
      <!-- My PeriodicPayout Tab -->
      <div
        class="tab-item me-2"
        [ngClass]="{ active: tab === 'PeriodicPayout' }"
        (click)="changeTab('PeriodicPayout')"
      >
        Payout List
      </div>
      <!-- LoanPayout  Tab -->
      <div
        class="tab-item me-2"
        [ngClass]="{ active: tab === 'LoanPayout' }"
        (click)="changeTab('LoanPayout')"
      >
        Single Loan Payout
      </div>
    </div>
  </div>
</div>
<div *ngIf="tab == 'PeriodicPayout'">
  <form class="formborder" #df="ngForm" novalidate>
    <div class="row m-0 col-md-12 p-0">
      <div class="col-md-2">
        <span>From Date</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            required
            placeholder="DD/MM/YYYY"
            name="FromDate"
            id="FromDate"
            #refFromdate="ngModel"
            class="form-control input-text-css"
            required
            [(ngModel)]="FromDate"
            [max]="ToDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span>To Date</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ToDate"
            id="ToDate"
            #refTodate="ngModel"
            class="form-control input-text-css"
            required
            [(ngModel)]="ToDate"
            [min]="FromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span class="required-lable"> Loan Accounting Category</span>
        <select
          name="selectedAccounting"
          id="selectedAccounting"
          class="form-control input-text-css"
          [(ngModel)]="selectedAccounting"
          #refselectedAccounting="ngModel"
          required
          [ngClass]="{
            'is-invalid': df.submitted && refselectedAccounting.invalid,
            'alert-warning':
              refselectedAccounting.invalid &&
              (refselectedAccounting.dirty ||
                refselectedAccounting.touched ||
                refselectedAccounting.untouched)
          }"
        >
          <option [ngValue]="null" selected>Select Report</option>
          <option *ngFor="let item of accountingData" [ngValue]="item">
            {{ item.Loan_category }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <button
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
          (click)="onAccountingSearch()"
        >
          Search
        </button>
      </div>
      <div
        class="col-md-3 float-right ml-2 mt-2"
        [hidden]="!periodicPayoutData"
      >
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
  <div class="mt-3" [hidden]="!periodicPayoutData">
    <div class="">
      <div class="table-responsive">
        <mat-table
          [dataSource]="periodicPayoutData"
          matSort
          matTableExporter
          #exporter="matTableExporter"
          style="max-width: 100%; overflow: auto; height: fit-content"
        >
          <!-- # -->
          <ng-container matColumnDef="Loan_Id">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              style="max-width: 50px"
              *matHeaderCellDef
              >#</mat-header-cell
            >
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 50px; max-height: 5px"
            >
              {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef
              ><strong>Total</strong></mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="LoanAcNo">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Loan No</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.LoanAcNo
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Loan_Date">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Loan Date</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Loan_Date
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="CustomerName">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Name</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.CustomerName
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Customer_PhoneNo">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >PhoneNo</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              <div *ngIf="currentUser.IsMaskingMobile">
                {{ row.Customer_PhoneNo | mask }}
              </div>
              <div *ngIf="!currentUser.IsMaskingMobile">
                {{ row.Customer_PhoneNo }}
              </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Address">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Address</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Address
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Loan Amount (Total) -->
          <ng-container matColumnDef="LoanAmount">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Loan Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell"
              >₹ {{ row.LoanAmount }}</mat-cell
            >
            <mat-footer-cell *matFooterCellDef
              >₹
              {{ getTotal("LoanAmount") | number : "1.2-2" }}</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="EMI_Frequency">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >EMI Frequency</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.EMI_Frequency
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="DueDate">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Due Date</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.DueDate
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="EMI_No">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >EMI No</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.EMI_No
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Customer EMI Amount (Total) -->
          <ng-container matColumnDef="customer_EMI_AMount">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Customer EMI Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.customer_EMI_AMount
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("customer_EMI_AMount") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- DSA EMI Amount (Total) -->
          <ng-container matColumnDef="DSA_EMI_AMount">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >DSA EMI Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.DSA_EMI_AMount
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("DSA_EMI_AMount") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- Payout EMI (Total) -->
          <ng-container matColumnDef="Diff_EMI_AMount">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Payout EMI</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Diff_EMI_AMount
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("Diff_EMI_AMount") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- Customer Interest (Total) -->
          <ng-container matColumnDef="customer_Interest">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Customer Interest</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.customer_Interest
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("customer_Interest") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- DSA Interest (Total) -->
          <ng-container matColumnDef="DSA_Interest">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >DSA Interest</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.DSA_Interest
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("DSA_Interest") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- Payout Interest (Total) -->
          <ng-container matColumnDef="Diff_Interest">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              *matHeaderCellDef
              >Payout Interest</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Diff_Interest
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              getTotal("Diff_Interest") | number : "1.2-2"
            }}</mat-footer-cell>
          </ng-container>

          <!-- Add other columns as needed, with empty footer cells if no total required -->

          <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
        </mat-table>
        <div class="row m-0 align-items-center">
          <div class="col-md-4">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="exportPeriodicData(exporter)"
            >
              <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Export
            </button>
          </div>
          <div class="col-md-8 mt-3">
            <mat-paginator
              #paginatorRef
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="tab == 'LoanPayout'">
  <div class="formborder" style="padding: 0px !important">
    <h1 class="fs-12 h-b">Loan Information</h1>
    <div class="row m-1">
      <div class="col-md-2">
        <input
          required
          type="text"
          placeholder=""
          name="AppCaseNo"
          id="AppCaseNo"
          readonly
          [(ngModel)]="AppCaseNo"
          class="form-control input-text-css"
        />
        <button
          type="button"
          (click)="searchCustomer()"
          class="primary-btn ml-2 search"
        >
          <i
            class="fa fa-search"
            aria-hidden="true"
            style="font-size: 12px"
          ></i>
        </button>
      </div>
      <div
        class="col-md-4"
        style="height: 100%; display: flex; align-items: center"
        [hidden]="!dataSourceCustomerLoan"
      >
        <h6 class="fs-12 mr-2">Customer Name:</h6>
        <p class="fs-12 mb-2">{{ CustomerN }}</p>
      </div>
    </div>
  </div>
  <!-- Model -->
  <div
    class="modal fade in"
    id="CustomerReceipt"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    data-backdrop="false"
    style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Customer Receipt
          </h6>
          <button
            type="button"
            (click)="onCloseReceipt()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><i class="far text-black fa-times-circle"></i
            ></span>
          </button>
        </div>
        <div class="modal-body">
          <form
            #f="ngForm"
            (keydown.enter)="onSearchCustomerDetail()"
            novalidate
            class="formborder"
          >
            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-2">
                <span>Application No.</span>
                <input
                  name="SApplicationNo"
                  [(ngModel)]="Customer.ApplicationNo"
                  id="SApplicationNo"
                  placeholder="Application No."
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Loan No.</span>
                <input
                  name="SLoanNo"
                  [(ngModel)]="Customer.LoanNo"
                  id="SLoanNo"
                  placeholder="Loan No."
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Customer Name</span>
                <input
                  name="CustomerName"
                  [(ngModel)]="Customer.CustomerName"
                  id="CustomerName"
                  placeholder="Customer Name"
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Customer Phone</span>
                <input
                  name="CustomerPhone"
                  [(ngModel)]="Customer.CustomerPhone"
                  id="CustomerPhone"
                  placeholder="Customer Phone"
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>PAN Card</span>
                <input
                  name="PANCard"
                  [(ngModel)]="Customer.PANCard"
                  id="PANCard"
                  placeholder="PAN Card"
                  class="form-control input-text-css"
                />
              </div>

              <div class="col-md-2">
                <span>Passport No.</span>
                <input
                  name="Passport"
                  [(ngModel)]="Customer.Passport"
                  id="Passport"
                  placeholder="Passport No."
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Voter ID Card</span>
                <input
                  name="VoterID"
                  [(ngModel)]="Customer.VoterID"
                  id="VoterID"
                  placeholder="Voter ID Card"
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Driving License</span>
                <input
                  name="DL"
                  [(ngModel)]="Customer.DL"
                  id="DL"
                  placeholder="Driving License"
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Aadhaar Card</span>
                <input
                  name="Aadhaar"
                  [(ngModel)]="Customer.Aadhaar"
                  id="Aadhaar"
                  placeholder="Aadhaar Card"
                  class="form-control input-text-css"
                />
              </div>
              <div class="col-md-2">
                <span>Date From</span>
                <div class="datepicker_feild">
                  <input
                    [matDatepicker]="picker"
                    dateConvert
                    placeholder="DD/MM/YYYY"
                    name="LoanDateFrom"
                    id="LoanDateFrom"
                    class="form-control input-text-css"
                    [(ngModel)]="Customer.LoanDateFrom"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <div class="col-md-2">
                <span>Date To</span>
                <div class="datepicker_feild">
                  <input
                    [matDatepicker]="picker2"
                    dateConvert
                    placeholder="DD/MM/YYYY"
                    name="LoanDateTo"
                    id="LoanDateTo"
                    class="form-control input-text-css"
                    [(ngModel)]="Customer.LoanDateTo"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
              </div>
              <div class="col-md-3">
                <span>Select Type</span>
                <select
                  name="SelectType"
                  id="SelectType"
                  class="form-control input-text-css"
                  [(ngModel)]="SelectType"
                  (change)="SearchChange()"
                >
                  <option value="">Select Type</option>
                  <option value="Branch">Branch</option>
                  <option value="CollArea">Collection Area</option>
                  <option value="CollSubArea">Collection Sub Area</option>
                  <option value="CollExecutive">Collection Executive</option>
                  <option value="SalesExecutive">Sales Executive</option>
                  <option value="EngineNo">Engine No.</option>
                  <option value="ChassisNo">Chassis No.</option>
                  <option value="LoanAccCatg">Loan A/C Category</option>
                </select>
              </div>
              <div class="col-md-3">
                <div *ngIf="SelectType == 'Branch'">
                  <span> Branch</span>
                  <select
                    name="BranchId"
                    id="BranchId"
                    #refSelectGender="ngModel"
                    [(ngModel)]="Customer.BranchId"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Branch</option>
                    <option
                      *ngFor="let branch of BranchesList"
                      [value]="branch.BranchId"
                    >
                      {{ branch.Branch_Name }}
                    </option>
                  </select>
                </div>

                <div *ngIf="SelectType == 'EngineNo'">
                  <span>Engine No.</span>
                  <input
                    name="EngineNo"
                    [(ngModel)]="Customer.EngineNo"
                    id="EngineNo"
                    placeholder="Engine No."
                    class="form-control input-text-css"
                  />
                </div>

                <div *ngIf="SelectType == 'ChassisNo'">
                  <span>Chassis No.</span>
                  <input
                    name="ChassisNo"
                    [(ngModel)]="Customer.ChassisNo"
                    id="ChassisNo"
                    placeholder="Chassis No."
                    class="form-control input-text-css"
                  />
                </div>

                <div *ngIf="SelectType == 'CollArea'">
                  <span> Collection Area</span>
                  <select
                    name="Area"
                    id="Area"
                    [(ngModel)]="Customer.Area"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Collection Area</option>
                    <ng-container *ngFor="let area of areaData">
                      <option
                        *ngIf="area.Type.trim() == 'Collection Area'"
                        [value]="area.Int_Id"
                      >
                        {{ area.Area_Name }}
                      </option>
                    </ng-container>
                  </select>
                </div>

                <div *ngIf="SelectType == 'CollSubArea'">
                  <span> Collection Sub Area</span>
                  <select
                    name="SubArea"
                    id="SubArea"
                    [(ngModel)]="Customer.SubArea"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Collection SubArea</option>
                    <option
                      *ngFor="let subarea of subAreaData"
                      [value]="subarea.Int_Id"
                    >
                      {{ subarea.Sub_Area_Name }}
                    </option>
                  </select>
                </div>

                <div *ngIf="SelectType == 'SalesExecutive'">
                  <span> Sales Executive</span>
                  <select
                    name="SalesEx"
                    id="SalesEx"
                    [(ngModel)]="Customer.SalesEx"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Sales Executive</option>
                    <option
                      *ngFor="let SalesExec of SalesExecutiveData"
                      [value]="SalesExec.EmpId"
                    >
                      {{ SalesExec.EmpName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="SelectType == 'CollExecutive'">
                  <span> Collection Executive</span>
                  <select
                    name="CollectionEx"
                    id="CollectionEx"
                    [(ngModel)]="Customer.CollectionEx"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Collection Executive</option>
                    <option
                      *ngFor="let CollExec of CollectionExecutiveData"
                      [value]="CollExec.EmpId"
                    >
                      {{ CollExec.Emp_FirstName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="SelectType == 'LoanAccCatg'">
                  <span>Accounting Category </span>
                  <select
                    name="LoanAccountingCatId"
                    id="LoanAccountingCatId"
                    [(ngModel)]="Customer.LoanAccountingCatId"
                    class="form-control input-text-css"
                  >
                    <option value="">Select Accounting Category</option>
                    <option
                      *ngFor="let AcCat of accountingData"
                      [value]="AcCat.Loan_CategoryId"
                    >
                      {{ AcCat.Loan_category }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3 text-right">
                <button
                  type="button"
                  (click)="onSearchCustomerDetail()"
                  class="mt-3 btn font-size-12 button-btn"
                >
                  Search
                </button>
              </div>

              <div class="col-md-3 mt-2" [hidden]="!dataSourceCustomer">
                <form action="" class="search-text">
                  <div class="bg-light rounded rounded-pill shadow-sm">
                    <div class="input-group">
                      <input
                        type="text"
                        id="FilterInputSearch"
                        (keyup)="applyFilter($event.target.value)"
                        name="FilterInputSearch"
                        placeholder="What're you searching for?"
                        class="form-control border-0 bg-light"
                      />
                      <div class="input-group-append">
                        <button
                          id="button-addon1"
                          type="submit"
                          class="btn btn-link text-primary"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </form>

          <div class="mt-2" [hidden]="!dataSourceCustomer">
            <div class="">
              <div class="table-responsive">
                <mat-table
                  [dataSource]="dataSourceCustomer"
                  #sortList="matSort"
                  matSort
                  id="exportReport"
                  style="max-width: 100%; overflow: auto"
                >
                  <ng-container matColumnDef="CustomerId">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                      >#</mat-header-cell
                    >
                    <mat-cell
                      *matCellDef="let row; let i = index"
                      class="grid-cell"
                    >
                      {{
                        paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1)
                      }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Type">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                      >Type</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">{{
                      row.Type
                    }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Application_No">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                      >Aplication No</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">
                      {{ row.Application_No }}</mat-cell
                    >
                  </ng-container>

                  <ng-container matColumnDef="LoanAcNo">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                    >
                      Loan No</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">{{
                      row.LoanAcNo
                    }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="CustomertName">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                    >
                      Customer</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell"
                      >{{ row.CustomertName }}({{
                        row.AC_CustomerType
                      }})</mat-cell
                    >
                  </ng-container>

                  <ng-container matColumnDef="FatherName">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                      >Relation Name</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">{{
                      row.FatherName
                    }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Customer_Gender">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                      >Gender</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">{{
                      row.Customer_Gender
                    }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="GenderAge">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                    >
                      Age</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">{{
                      row.GenderAge
                    }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="PhoneNo">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                    >
                      Phone No</mat-header-cell
                    >
                    <mat-cell *matCellDef="let row" class="grid-cell">
                      <div *ngIf="currentUser.IsMaskingMobile">
                        {{ row.PhoneNo | mask }}
                      </div>

                      <div *ngIf="!currentUser.IsMaskingMobile">
                        {{ row.PhoneNo }}
                      </div>

                      <i
                        *ngIf="row.Customer_PhoneNo_IsVerified == true"
                        class="fa fa-check-circle ml-2"
                        style="color: green"
                      ></i>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="EditAction">
                    <mat-header-cell
                      mat-sort-header
                      class="grid-header"
                      *matHeaderCellDef
                    >
                      View Detail</mat-header-cell
                    >
                    <mat-cell
                      *matCellDef="let row"
                      class="grid-cell j-c-center"
                    >
                      <i
                        class="fa fa-arrow-circle-right arrow-circle action-btn"
                        (click)="goToDetail(row)"
                        aria-label="true"
                      ></i>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row
                    class="sticky-footer"
                    *matHeaderRowDef="displayedCustomerColumns; sticky: true"
                  ></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: displayedCustomerColumns"
                  ></mat-row>
                </mat-table>

                <mat-paginator
                  #paginatorRef
                  #PaginatorList
                  [pageSizeOptions]="[20, 50]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- outside model table -->
  <div class="mt-2" [hidden]="!dataSourceCustomerLoan">
    <div class="">
      <div class="table-responsive">
        <mat-table
  [dataSource]="dataSourceCustomerLoan"
  #sortList="matSort"
  matSort
  id="exportReport"
  matTableExporter
  #exporter="matTableExporter"
  style="width: 100%; overflow: auto; height: fit-content"
>
  <!-- Period -->
  <ng-container matColumnDef="Period">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef style="max-width: 50px">#</mat-header-cell>
    <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 50px">
      {{ paginatorRef1.pageIndex * paginatorRef1.pageSize + (i + 1) }}
    </mat-cell>
    <mat-footer-cell *matFooterCellDef><strong>Total</strong></mat-footer-cell>
  </ng-container>

  <!-- Due Date (no total) -->
  <ng-container matColumnDef="DueDate">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Due Date</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.DueDate }}</mat-cell>
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <!-- EMI Amount -->
  <ng-container matColumnDef="EMI_Amount">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>EMI Amount</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.EMI_Amount }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('EMI_Amount') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- Interest -->
  <ng-container matColumnDef="Interest">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Interest</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Interest }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('Interest') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- Principle -->
  <ng-container matColumnDef="Principle">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Principle</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Principle }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('Principle') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- Outstanding Principle -->
  <ng-container matColumnDef="Outstanding_Principle">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Outstanding Principle</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Outstanding_Principle }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('Outstanding_Principle') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- DSA EMI Amount -->
  <ng-container matColumnDef="DSA_EMI_Amount">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>DSA EMI Amount</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.DSA_EMI_Amount }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('DSA_EMI_Amount') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- DSA Interest -->
  <ng-container matColumnDef="DSA_Interest">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>DSA Interest</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell j-c-center">{{ row.DSA_Interest }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('DSA_Interest') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- DSA Principle -->
  <ng-container matColumnDef="DSA_Principle">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>DSA Principle</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.DSA_Principle }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('DSA_Principle') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- DSA Outstanding Principle -->
  <ng-container matColumnDef="DSA_Outstanding_Principle">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>DSA Outstanding Principle</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.DSA_Outstanding_Principle }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('DSA_Outstanding_Principle') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- Payout EMI -->
  <ng-container matColumnDef="Diff_EMI_AMount">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Payout EMI</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Diff_EMI_AMount }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('Diff_EMI_AMount') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <!-- Payout Interest -->
  <ng-container matColumnDef="Diff_Interest">
    <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Payout Interest</mat-header-cell>
    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Diff_Interest }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>{{ getLoanTotal('Diff_Interest') | number:'1.2-2' }}</mat-footer-cell>
  </ng-container>

  <mat-header-row class="sticky-footer" *matHeaderRowDef="displayLoanCustomerColumn; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayLoanCustomerColumn"></mat-row>
  <mat-footer-row *matFooterRowDef="displayLoanCustomerColumn"></mat-footer-row>
</mat-table>
        <div class="row m-0 align-items-center">
          <div class="col-md-4">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="exportloanInfoData(exporter)"
            >
              <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Export
            </button>
          </div>
          <mat-paginator
            #paginatorRef1
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
